import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as TextIcon } from "../../../../../assets/MainPage/addBlock/countDown/text.svg";
import { ReactComponent as ContactIcon } from "../../../../../assets/MainPage/addBlock/countDown/call.svg";
import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";

import { ReactComponent as Whatsapp } from "../../../../../assets/MainPage/addBlock/countDown/whatsapp.svg";
import { ReactComponent as WhatsappDark } from "../../../../../assets/MainPage/addBlock/countDown/whatsapp-dark.svg";
import { ReactComponent as ImagePlacholderDark } from "../../../../../assets/dashboard/avatar/gallery-dark.svg";
import { ReactComponent as ImagePlacholder } from "../../../../../assets/dashboard/avatar/gallery.svg";

import { ReactComponent as DownArrowIcon } from "../../../../../assets/appearencePage/arrow-down.svg";
import { ReactComponent as DownArrowIconDark } from "../../../../../assets/appearencePage/arrow-down-dark.svg";
import { ReactComponent as Brush } from "../../../../../assets/appearencePage/brush.svg";
import { ReactComponent as BrushDark } from "../../../../../assets/appearencePage/brush-dark.svg";

import { ReactComponent as Outline } from "../../../../../assets/appearencePage/outlineIcon.svg";
import { ReactComponent as OutlineDark } from "../../../../../assets/appearencePage/outlineIcon-dark.svg";
import { ReactComponent as ContactIconDark } from "../../../../../assets/MainPage/addBlock/countDown/call-dark.svg";
import { ReactComponent as TextIconDark } from "../../../../../assets/MainPage/addBlock/countDown/text-dark.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";

import { useForm } from "react-hook-form";
import { ColorPicker, useColor } from "react-color-palette";

import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import { ReactComponent as ImagePlceHolder } from "../../../../../assets/settingPage/profilePlacholder.svg";

import HeaderTextEditor from "../forms/HeaderTextEditor";
import httpFormRequest from "../../../../../axios/form_index";

import { Link, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import useFetchBlock from "../../../../../hooks/useFetchBlock";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import {
  deleteBlock,
  resetDeletBlock,
} from "../../../../../redux/slices/block/deleteBlockSlice";

import ConfirmModal from "../../../../../components/dashboard/modal/Confirm";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

import SpinnerGiff from "../../../../../assets/spinner.svg";
import { FileUploader } from "react-drag-drop-files";
import { I18nextProvider } from "react-i18next";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";
const fileTypes = ["png", "jpg", "jpeg", "gif", "ico"];
const outLineType = ["none", "dashed", "dotted", "double", "solid"];
const outLineWidth = ["none", "1px", "2px", "4px", "8px"];

const inputErrorClasses =
  "border-state_color_error placeholder:text-state_color_error";
const inputNoErrorClasses =
  "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color";

const EditAvatar = () => {
  const { translate, allLangs, tComponent, handleLanguageChange } =
    useLocales();
  const { darkMode } = useSelector((state) => state.theme);

  const baseUrl = process.env.REACT_APP_API_URL;
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { themeDirection } = useSettings();
  const { setActiveMainPageNav } = useStateContext();
  const { optionId } = useParams();

  const [editorValue, setEditorValue] = useState("");
  const [avatarImage, setAvatarImage] = useState(null);
  const [subLoader, setSubLoader] = useState(false);

  const [filePreview, setFilePreview] = useState(null);
  const [file, setFile] = useState(null);
  const [alignment, setAlignment] = useState("left"); // State for profile alignment
  const [backgroundNeeded, setBackgroundNeeded] = useState(true); // State for background image needed

  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  const [color, setColor] = useColor("#561ecb");
  useEffect(() => {
    setAvatarColorHandler(color);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [color]);
  const outLineStyleDropDownRef = useRef();
  const outLineStyleDropDownBtnRef = useRef();
  const outLineWidthDropDownRef = useRef();
  const outLineWidthDropDownBtnRef = useRef();

  const outlineColrDropDownRef = useRef();
  const outlineColrDropDownBtnRef = useRef();

  const [selectedSize, setSelectedSize] = useState("75x75");
  const [selectedShape, setSelectedShape] = useState("circle");
  const [selectedOutlineType, setSelectedOutlineType] = useState("");
  const [selectedOutlineWidth, setSelectedOutlineWidth] = useState("");

  const [outLineStlyDropdown, setOutLineStlyDropdown] = useState(false);
  const [outLineWidthDropdown, setOutLineWidthDropdown] = useState(false);

  const [colorAvatar, setColorAvatar] = useState("#CAFF");
  const [openAvatarColopicker, setOpenAvatarColopicker] = useState(false);

  const blockFeature = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.response
  );
  const paymenetBlocks = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
  );

  // FAQ
  const headerCheck = blockFeature?.some(
    (item) => item.name === "Header" && paymenetBlocks === 1
  );

  const setAvatarColorHandler = (color) => {
    setColorAvatar(color.hex);
  };
  // outline style dropdown handler

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        outLineStlyDropdown &&
        outLineStyleDropDownRef.current &&
        !outLineStyleDropDownRef.current.contains(e.target) &&
        !outLineStyleDropDownBtnRef.current.contains(e.target)
      ) {
        setOutLineStlyDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outLineStlyDropdown]);

  // outline width dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        outLineWidthDropdown &&
        outLineWidthDropDownRef.current &&
        !outLineWidthDropDownRef.current.contains(e.target) &&
        !outLineWidthDropDownBtnRef.current.contains(e.target)
      ) {
        setOutLineWidthDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outLineWidthDropdown]);

  // Outline color dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        openAvatarColopicker &&
        outlineColrDropDownRef.current &&
        !outlineColrDropDownRef.current.contains(e.target) &&
        !outlineColrDropDownBtnRef.current.contains(e.target)
      ) {
        setOpenAvatarColopicker(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAvatarColopicker]);

  const handleChange = (file) => {
    setFile(file);
    setFilePreview(URL.createObjectURL(file));
  };

  const handleEditorChange = (value) => {
    setEditorValue(value);
  };

  useEffect(() => {
    setActiveMainPageNav(true);
    return () => {
      setActiveMainPageNav(false);
    };
  }, []);

  const [prevData, setPrevData] = useState(null);
  const url = baseUrl + "/api/user/getOption/" + userId + "/" + optionId;

  const { data, loading, error } = useFetchBlock(url);

  useEffect(() => {
    setPrevData({
      ...data?.data,
      coloum_value:
        data?.data?.coloum_value && JSON.parse(data?.data?.coloum_value),
    });
    if (error) {
      toast.error("Something went wrong...");
    }
  }, [data, error]);

  const linkId = localStorage.getItem("linkId");

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const EditSubmitHandler = async (data) => {
    setSubLoader(true);

    const avatarOutline = {
      outline_style: selectedOutlineType,
      outline_width: selectedOutlineWidth,
      outline_colour: colorAvatar,
    };
    const avatarOutlineString = JSON.stringify(avatarOutline);

    try {
      const url = "/api/user/updateHeaderBlock";
      const bodyFormData = new FormData();

      if (data?.avatarUrl) {
        bodyFormData.append("picture", data?.avatarUrl);
      }
      if (file) {
        bodyFormData.append("backgroundImage", file);
      }
      bodyFormData.append("coloum_name", "headertext");
      bodyFormData.append("coloum_type", "headertext");
      bodyFormData.append("pageName", data?.pageName);
      bodyFormData.append("pageTitle", data?.pageTitle);
      bodyFormData.append("contact", data?.contact);
      bodyFormData.append("whatsapp", data?.whatsapp);
      bodyFormData.append("description", editorValue);
      bodyFormData.append("alignment", alignment);
      bodyFormData.append("avatar_size", selectedSize);
      bodyFormData.append("avatar_shape", selectedShape);
      bodyFormData.append("avatar_outline", avatarOutlineString);
      bodyFormData.append("optionId", optionId);
      bodyFormData.append("linkId", linkId);
      bodyFormData.append("userid", userId);
      bodyFormData.append("language", selectedLang);

      const response = await httpFormRequest.put(url, bodyFormData);
      const result = response?.data?.message;
      const status = response?.data?.status;
      if (status === "success") {
        toast.success(result);
        reset();
        setValue("avatarUrl", null);
        setEditorValue("");
        navigate("/dashboard/component");
        fetchingLinksList();
      }
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    } finally {
      setSubLoader(false);
    }
  };

  const avatarOutlines = prevData?.coloum_value?.avatar_outline
    ? JSON.parse(prevData.coloum_value.avatar_outline)
    : null;

  useEffect(() => {
    if (prevData) {
      setValue("pageName", prevData?.coloum_value?.pageName);
      setValue("pageTitle", prevData?.coloum_value?.pageTitle);
      setValue("contact", prevData?.coloum_value?.contact);
      setValue("whatsapp", prevData?.coloum_value?.whatsapp);
      setAlignment(prevData?.coloum_value?.alignment);
      setAvatarImage(
        prevData?.coloum_value?.image
          ? baseUrl + "/profile/" + prevData?.coloum_value?.image
          : null
      );
      setFilePreview(
        prevData?.coloum_value?.backGroundImage
          ? baseUrl + "/profile/" + prevData?.coloum_value?.backGroundImage
          : null
      );
      setEditorValue(prevData?.coloum_value?.description);
      setSelectedSize(prevData?.coloum_value?.avatar_size);
      setSelectedShape(prevData?.coloum_value?.avatar_shape);
      setSelectedOutlineType(avatarOutlines?.outline_style);
      setSelectedOutlineWidth(avatarOutlines?.outline_width);
      setColorAvatar(avatarOutlines?.outline_colour || "#CAFF");
      setColor((color) => {
        return {
          ...color,
          hex: avatarOutlines?.outline_colour || "#CAFF",
        };
      });
      if (prevData?.language) {
        setSelectedLang(prevData?.language);
        const matchedLang = allLangs?.find(
          (lang) => lang.value === prevData?.language
        );
        const shouldSetLang = matchedLang?.label;
        setSelectedReporterType(shouldSetLang);
        handleLanguageChange(prevData?.language);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevData]);

  const fetchingLinksList = () => {
    // data need for fetching link list
    const usertoken = user.token;
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    dispatch(gettingLinkList(linkListData));
  };

  const docFile = watch("avatarUrl");

  const fileChangeHandler = (e) => {
    const selectedFile = e.target.files?.[0];

    if (selectedFile && selectedFile.size > 375000) {
      toast.error(`${tComponent("header.image_smaller_than_3MB")}`);
    } else {
      if (selectedFile) {
        setValue("avatarUrl", selectedFile);
      }
    }
  };

  const ChooseAvatar = async () => {
    document.getElementById("avatarUrl").click();
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const deleteHandler = async () => {
    const obj = {
      optionId: optionId,
      userId: userId,
    };
    await dispatch(deleteBlock(obj)).then(() => {});
  };

  const handleDeleteModal = () => {
    deleteHandler();
    setIsModalOpen(false);
  };

  //  delete block api response state handler
  const {
    DeleteBlock,
    isDeleteBlockError,
    isDeleteBlockSuccess,
    isDeleteBlockLoading,
    isDeleteBlockErrorMsg,
  } = useSelector((state) => state?.deleteBlock);

  useEffect(() => {
    if (DeleteBlock?.data?.status === "success" && isDeleteBlockSuccess) {
      toast.success(DeleteBlock?.data?.message);
      fetchingLinksList();
      navigate("/dashboard/component");
    }
    if (DeleteBlock?.data?.status === "failed" && isDeleteBlockSuccess) {
      toast.error(DeleteBlock?.data?.message);
    }
    if (isDeleteBlockError) {
      toast.error(isDeleteBlockErrorMsg);
    }
    dispatch(resetDeletBlock());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteBlockLoading, DeleteBlock]);

  // Function to toggle profile alignment
  const handleAlignmentChange = (value) => {
    setAlignment(value);
  };

  // Function to toggle background image needed
  const handleBackgroundChange = (value) => {
    if (value === "yes") {
      setBackgroundNeeded(true);
    } else {
      setBackgroundNeeded(false);
      setFilePreview(null); // Set background image state to null
    }
  };

  return (
    <>
      <ConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleDeleteModal}
        selectedLang={selectedLang}
      />
      {loading && (
        <div
          style={{ zIndex: "999999" }}
          className="fixed inset-0 h-screen bg-[#ffffffa7] pt-5 flex justify-center items-center overflow-hidden"
        >
          <img src={SpinnerGiff} alt="..." />
        </div>
      )}
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark">
              {translate("addBlock.header")}
            </p>
          </div>
        </Link>
      </div>
      <I18nextProvider i18n={i18nForComponent}>
        <div
          className="sm:mt-7 md:px-0 mt-10 mb-6 px-6"
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
        >
          <div className="border rounded-[10px] bg-light_bg_v5 dark:bg-dark-secondary p-[25px] dark:border-color_dark">
            <div className="flex justify-between items-center mb-[20px] sm:mb-[25px] ">
              <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark uppercase">
                {tComponent("header.edit_header")}
              </p>
              <div
                className={`w-[100px] bg-light_bg_v4 capitalize p-[10px] text-small2 lg:text-body_copy2 rounded-md flex justify-center items-center`}
              >
                {selectedReporterType ? selectedReporterType : "English"}
              </div>
            </div>
            <div className="flex mt-5 lg:mt-[25px] items-center">
              {docFile && docFile instanceof Blob ? (
                <div className="flex items-center relative">
                  <label htmlFor="avatarUrl">
                    <div className="absolute inset-0 z-20 opacity-0 bg-[#D9D9D9] border-heading_color flex justify-center items-center cursor-pointer h-[30px] lg:h-[10px] w-[70px] lg:w-[70px]">
                      {darkMode ? <ImagePlacholderDark /> : <ImagePlacholder />}
                    </div>
                    <div className="border border-gray-300 dark:border-border_transparent rounded bg-[#D9D9D9] flex justify-center items-center cursor-pointer h-[70px] lg:h-[70px] w-[70px] lg:w-[70px]">
                      <img
                        className="h-full w-full object-cover"
                        src={URL.createObjectURL(docFile)}
                        alt="..."
                      />
                    </div>
                    <input
                      id="avatarUrl"
                      type="file"
                      onChange={(e) => fileChangeHandler(e)}
                      accept="image/*"
                      className="hidden"
                    />
                  </label>
                </div>
              ) : prevData?.coloum_value?.image ? (
                <div className="flex items-center relative">
                  <label htmlFor="avatarUrl">
                    <div className="absolute inset-0 z-20 opacity-0 bg-[#D9D9D9] border-heading_color flex justify-center items-center cursor-pointer h-[30px] lg:h-[10px] w-[70px] lg:w-[70px]">
                      {darkMode ? <ImagePlacholderDark /> : <ImagePlacholder />}
                    </div>
                    <div className="dark:border-border_transparent border border-gray-300 rounded bg-[#D9D9D9] flex justify-center items-center cursor-pointer h-[70px] lg:h-[70px] w-[70px] lg:w-[70px]">
                      <img
                        className="h-full w-full object-cover"
                        src={avatarImage}
                        alt="..."
                      />
                    </div>
                    <input
                      id="avatarUrl"
                      type="file"
                      onChange={(e) => fileChangeHandler(e)}
                      accept="image/*"
                      className="hidden"
                    />
                  </label>
                </div>
              ) : (
                <label htmlFor="avatarUrl">
                  <div className="dark:border-border_transparent border border-gray-300 dark:bg-dark-primary rounded bg-[#D9D9D9] flex justify-center items-center cursor-pointer h-[70px] lg:h-[70px] w-[70px] lg:w-[70px]">
                    {darkMode ? <ImagePlacholderDark /> : <ImagePlacholder />}
                  </div>
                  <input
                    id="avatarUrl"
                    type="file"
                    onChange={(e) => fileChangeHandler(e)}
                    accept="image/*"
                    className="hidden"
                  />
                </label>
              )}

              <div>
                <div className="flex items-center lg:gap-[15px]">
                  <button
                    onClick={() => ChooseAvatar()}
                    className="p-[6px] lg:p-[9px]  text-main_color text-small3_b lg:text-small2_b px-[22px] lg:px-[26px]"
                  >
                    {tComponent("header.choose_avatar")}
                  </button>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit((data) => EditSubmitHandler(data))}>
              <div className="mt-4 grid grid-cols-1 xl:grid-cols-2 gap-4">
                <div className="col-span-1 mt-[-9px]">
                  <div className="mt-2">
                    <div>
                      <div className="relative">
                        <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                          {darkMode ? <TextIconDark /> : <TextIcon />}
                        </div>
                        <input
                          type="text"
                          id="pageName"
                          autocomplete="off"
                          {...register("pageName", {
                            required: tComponent("header.pagename_required"),
                          })}
                          className={`rounded-md border bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                            errors.pageName
                              ? "border-state_color_error dark:bg-dark-secondary"
                              : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                          }`}
                          placeholder={tComponent("header.enter_page_name")}
                        />
                      </div>
                      {errors?.pageName && (
                        <small className="text-state_color_error text-small3">
                          {errors?.pageName?.message}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="mt-2">
                    <div>
                      <div className="relative">
                        <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                          {darkMode ? <TextIconDark /> : <TextIcon />}
                        </div>
                        <input
                          type="text"
                          id="pageTitle"
                          autocomplete="off"
                          {...register("pageTitle", {
                            required: tComponent("header.pagetitle_required"),
                          })}
                          className={`rounded-md border bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                            errors.pageTitle
                              ? "border-state_color_error dark:bg-dark-secondary"
                              : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                          }`}
                          placeholder={tComponent("header.enter_page_title")}
                        />
                      </div>
                      {errors?.pageTitle && (
                        <small className="text-state_color_error text-small3">
                          {errors?.pageTitle?.message}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="mt-2">
                    <div>
                      <div className="relative">
                        <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                          {darkMode ? <ContactIconDark /> : <ContactIcon />}
                        </div>
                        <input
                          type="number"
                          id="contact"
                          autocomplete="off"
                          {...register("contact", {
                            required: tComponent("header.contact_required"),
                          })}
                          className={`rounded-md border bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                            errors.contact
                              ? "border-state_color_error dark:bg-dark-secondary"
                              : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                          }`}
                          placeholder={tComponent("header.contact")}
                        />
                      </div>
                      {errors?.contact && (
                        <small className="text-state_color_error text-small3">
                          {errors?.contact?.message}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="mt-2">
                    <div>
                      <div className="relative">
                        <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                          {darkMode ? <WhatsappDark /> : <Whatsapp />}
                        </div>
                        <input
                          type="number"
                          id="whatsapp"
                          autocomplete="off"
                          {...register("whatsapp", {
                            required: tComponent("header.whatapp_required"),
                          })}
                          className={`rounded-md border bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                            errors.whatsapp
                              ? "border-state_color_error dark:bg-dark-secondary"
                              : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                          }`}
                          placeholder={tComponent("header.whatapp")}
                        />
                      </div>
                      {errors?.whatsapp && (
                        <small className="text-state_color_error text-small3">
                          {errors?.whatsapp?.message}
                        </small>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-span-1 mt-3 md:mt-0">
                  <div className="relative h-94">
                    <HeaderTextEditor
                      value={editorValue}
                      onChange={handleEditorChange}
                    />
                  </div>
                </div>
              </div>

              {headerCheck && (
                <>
                  {/* Alignment section */}

                  <div>
                    <p className="text-small2_b sm:text-small1_bold mb-[20px] mt-[30px] text-heading_color dark:text-color_v1_dark uppercase">
                      {tComponent("header.profile_alignment")}
                    </p>
                    <div className="flex">
                      <div className="flex items-center">
                        <input
                          id="left"
                          type="radio"
                          checked={alignment === "left"}
                          onChange={() => handleAlignmentChange("left")}
                          className="w-4 h-4 accent-main_color bg-gray-100 border-gray-300    dark:bg-gray-700 dark:border-gray-600"
                        ></input>
                        <label
                          htmlFor="left"
                          className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          {tComponent("header.left")}
                        </label>
                      </div>
                      <div className="flex items-center ml-8">
                        <input
                          id="center"
                          type="radio"
                          checked={alignment === "center"}
                          onChange={() => handleAlignmentChange("center")}
                          className="w-4 h-4 accent-main_color bg-gray-100 border-gray-300    dark:bg-gray-700 dark:border-gray-600"
                        ></input>
                        <label
                          htmlFor="center"
                          className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          {tComponent("header.center")}
                        </label>
                      </div>
                      <div className="flex items-center ml-8">
                        <input
                          id="right"
                          type="radio"
                          checked={alignment === "right"}
                          onChange={() => handleAlignmentChange("right")}
                          className="w-4 h-4 accent-main_color bg-gray-100 border-gray-300    dark:bg-gray-700 dark:border-gray-600"
                        ></input>
                        <label
                          htmlFor="right"
                          className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          {tComponent("header.right")}
                        </label>
                      </div>
                    </div>
                    <p className="w-auto lg:w-max text-small2_b sm:text-small1_bold mb-[20px] mt-[30px] text-heading_color dark:text-color_v1_dark uppercase">
                      {tComponent("header.want_to_set_background_image")}
                    </p>
                    <div className="flex">
                      <div className="flex items-center">
                        <input
                          id="yes"
                          type="radio"
                          checked={backgroundNeeded}
                          onChange={() => handleBackgroundChange("yes")}
                          className="w-4 h-4 accent-main_color bg-gray-100 border-gray-300    dark:bg-gray-700 dark:border-gray-600"
                        ></input>
                        <label
                          htmlFor="yes"
                          className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          {tComponent("header.yes")}
                        </label>
                      </div>
                      <div className="flex items-center ml-10">
                        <input
                          id="no"
                          type="radio"
                          checked={!backgroundNeeded}
                          onChange={() => handleBackgroundChange("no")}
                          className="w-4 h-4 accent-main_color bg-gray-100 border-gray-300    dark:bg-gray-700 dark:border-gray-600"
                        ></input>
                        <label
                          htmlFor="no"
                          className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          {tComponent("header.no")}
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Avatar Section */}
                  {backgroundNeeded && (
                    <div className="bg-light_bg_v5 dark:bg-dark-secondary pt-[30px]">
                      {!filePreview && (
                        <FileUploader
                          handleChange={handleChange}
                          name="file"
                          types={fileTypes}
                          maxSize={2}
                          onSizeError={(errorMessage) =>
                            toast.error(errorMessage)
                          }
                          onTypeError={(errorMessage) =>
                            toast.error(errorMessage)
                          }
                          children={
                            <div>
                              <div className="flex items-center justify-center w-full">
                                <div className="flex flex-col items-center justify-center w-full py-[45px] px-5 border-2 border-dark_bg_v4 border-dashed rounded-lg cursor-pointer bg-light_bg_v5 dark:bg-dark-secondary hover:bg-gray-100 dark:border-color_dark dark:hover:border-gray-500 dark:hover:bg-gray-600">
                                  <div className="flex flex-col items-center justify-center">
                                    <div className="mb-[11px] h-[36px] w-[36]">
                                      {darkMode ? (
                                        <ImagePlacholderDark />
                                      ) : (
                                        <ImagePlacholder />
                                      )}
                                    </div>
                                    <p className="text-small3 mb-[5px] whitespace-nowrap text-font_light_color dark:text-color_v2_dark">
                                      {tComponent("header.drop_your_img")},
                                      &nbsp;
                                      <span className="text-small3_b text-main_color ">
                                        {tComponent(`header.browse_image`)}
                                      </span>
                                    </p>
                                    <p className="text-[10px] text-font_light_color dark:text-color_v2_dark tracking-[-0.3px] leading-[13px]">
                                      2 MB {tComponent("header.maximum")}
                                      (.png, .gif, .ico)
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        />
                      )}
                      {filePreview && (
                        <div>
                          <div className="flex items-center">
                            <div className="bg-light_bg_v4 dark:bg-dark-secondary rounded-lg cursor-pointer">
                              <img
                                className="h-[60px] w-[60px] sm:h-[68px] sm:w-[68px] p-1 object-cover rounded-lg"
                                src={filePreview}
                                alt=""
                              />
                            </div>
                            <div>
                              <FileUploader
                                handleChange={handleChange}
                                name="file"
                                types={fileTypes}
                                maxSize={2}
                                onSizeError={(errorMessage) =>
                                  toast.error(errorMessage)
                                }
                                onTypeError={(errorMessage) =>
                                  toast.error(errorMessage)
                                }
                                children={
                                  <div className="ps-[15px] text-small2_b text-main_color cursor-pointer">
                                    {tComponent(`header.choose_another`)}
                                  </div>
                                }
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  <div className="mt-[30px]">
                    <div
                      style={{
                        boxShadow:
                          "-2px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 6px 0px rgba(0, 0, 0, 0.02)",
                      }}
                      className="border border-light_bg_v4 rounded-md py-5 px-[20px] lg:px-[26px] dark:border-color_dark"
                    >
                      <div className="text-small1_bold mb-5 dark:text-color_v1_dark">
                        {tComponent("header.avatar_size")}
                      </div>
                      <div className="flex gap-[20px] flex-wrap lg:gap-9 lg:justify-between items-start">
                        <div
                          onClick={() => setSelectedSize("75x75")}
                          className={`dark:text-[#292D32] h-[55px] lg:h-[75px] w-[55px] lg:w-[75px] flex justify-center items-center text-center bg-[#fcdddb] text-[10px] font-semibold -tracking-[0.2px] lg:text-small3_b cursor-pointer  ${
                            selectedSize === "75x75"
                              ? "outline outline-1 outline-offset-[5px]"
                              : ""
                          }`}
                        >
                          75x75
                        </div>
                        <div
                          onClick={() => setSelectedSize("100x100")}
                          className={`dark:text-[#292D32] h-[80px] lg:h-[100px] w-[80px] lg:w-[100px] flex justify-center items-center text-center bg-[#fcdddb] text-[10px] font-semibold -tracking-[0.2px] lg:text-small3_b cursor-pointer ${
                            selectedSize === "100x100"
                              ? "outline outline-1 outline-offset-[5px]"
                              : ""
                          }`}
                        >
                          100x100
                        </div>
                        <div
                          onClick={() => setSelectedSize("125x125")}
                          className={`dark:text-[#292D32] h-[95px] lg:h-[125px] w-[95px] lg:w-[125px] flex justify-center items-center text-center bg-[#fcdddb] text-small3_b lg:text-small2_b cursor-pointer ${
                            selectedSize === "125x125"
                              ? "outline outline-1 outline-offset-[5px]"
                              : ""
                          }`}
                        >
                          125x125
                        </div>
                        <div
                          onClick={() => setSelectedSize("150x150")}
                          className={`dark:text-[#292D32] h-[115px] lg:h-[150px] w-[115px] lg:w-[150px] flex justify-center items-center text-center bg-[#fcdddb] text-small3_b lg:text-small2_b cursor-pointer ${
                            selectedSize === "150x150"
                              ? "outline outline-1 outline-offset-[5px]"
                              : ""
                          }`}
                        >
                          150x150
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        boxShadow:
                          "-2px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 6px 0px rgba(0, 0, 0, 0.02)",
                      }}
                      className="border mt-5 border-light_bg_v4 rounded-md py-5 px-[20px] lg:px-[26px] dark:border-color_dark"
                    >
                      <div className="text-small1_bold mb-5 dark:text-color_v1_dark">
                        {tComponent("header.avatar_shape")}
                      </div>
                      <div className="flex gap-[15px] lg:gap-9 justify-start items-start">
                        <div
                          onClick={() => setSelectedShape("circle")}
                          className={`dark:text-[#292D32] h-[70px] md:h-[55px] lg:h-[100px] w-[70px] md:w-[55px] lg:w-[100px] rounded-full flex justify-center items-center text-center bg-[#fcdddb] text-[10px] font-semibold -tracking-[0.2px] lg:text-small3_b cursor-pointer  ${
                            selectedShape === "circle"
                              ? "outline outline-1 outline-offset-[5px]"
                              : ""
                          }`}
                        >
                          {/* Circle */}
                          {tComponent("header.circle")}
                        </div>
                        <div
                          onClick={() => setSelectedShape("rounded")}
                          className={`dark:text-[#292D32] h-[70px] md:h-[55px] lg:h-[100px] w-[70px] md:w-[55px] lg:w-[100px] rounded-lg flex justify-center items-center text-center bg-[#fcdddb] text-[10px] font-semibold -tracking-[0.2px] lg:text-small3_b cursor-pointer ${
                            selectedShape === "rounded"
                              ? "outline outline-1 outline-offset-[5px]"
                              : ""
                          }`}
                        >
                          {/* Rounded */}
                          {tComponent("header.rounded")} <br /> {/*corners */}
                          {tComponent("header.corners")}
                        </div>
                        <div
                          onClick={() => setSelectedShape("straight")}
                          className={`dark:text-[#292D32] h-[70px] md:h-[55px] lg:h-[100px] w-[70px] md:w-[55px] lg:w-[100px] flex justify-center items-center text-center bg-[#fcdddb] text-[10px] font-semibold -tracking-[0.2px] lg:text-small3_b cursor-pointer ${
                            selectedShape === "straight"
                              ? "outline outline-1 outline-offset-[5px]"
                              : ""
                          }`}
                        >
                          {/* Straight */}
                          {tComponent("header.straight")}
                          <br />
                          {/*corners */}
                          {tComponent("header.corners")}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        boxShadow:
                          "-2px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 6px 0px rgba(0, 0, 0, 0.02)",
                      }}
                      className="border mt-5 border-light_bg_v4 rounded-md py-5 px-[20px] lg:px-[26px] dark:border-color_dark"
                    >
                      <div className="text-small1_bold mb-5 dark:text-color_v1_dark">
                        {tComponent("header.avatar_outline")}
                      </div>
                      <div className="relative">
                        <div
                          ref={outLineStyleDropDownBtnRef}
                          onClick={() =>
                            setOutLineStlyDropdown(!outLineStlyDropdown)
                          }
                          className="relative cursor-pointer flex gap-2.5 p-[13px] lg:p-[11px] px-[14px] lg:px-[15px] justify-between items-center rounded-md bg-light_bg_v4 dark:bg-[#404040]"
                        >
                          <div className="flex justify-center items-center">
                            {darkMode ? <OutlineDark /> : <Outline />}
                          </div>
                          <div className="w-full capitalize bg-transparent text-small2 lg:text-small1 dark:text-color_v1_dark">
                            {selectedOutlineType
                              ? selectedOutlineType
                              : "Style"}
                          </div>
                          <div className=" flex justify-center items-center">
                            {darkMode ? (
                              <DownArrowIconDark />
                            ) : (
                              <DownArrowIcon />
                            )}
                          </div>
                        </div>
                        {outLineStlyDropdown && (
                          <div
                            ref={outLineStyleDropDownRef}
                            className="absolute top-12 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5 dark:bg-[#404040] rounded-lg border flex flex-col max-h-36 overflow-y-auto"
                          >
                            {outLineType.map((item, i) => {
                              return (
                                <div
                                  key={i}
                                  onClick={() => {
                                    setSelectedOutlineType(item);
                                    setOutLineStlyDropdown(false);
                                  }}
                                  className="px-[10] lg:px-[15px] py-[7px] text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark cursor-pointer hover:bg-light_bg_v4 dark:hover:bg-dark-secondary rounded-md"
                                >
                                  <div
                                    style={{ borderStyle: item }}
                                    className={`w-full capitalize ${
                                      item === "solid"
                                        ? "border-2"
                                        : item === "double"
                                        ? "border-double border-4"
                                        : "border-2 border-" + item
                                    } border-heading_color dark:border-color_v2_dark p-1 lg:p-2 py-0.5 lg:py-1`}
                                  >
                                    {item}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                      <div className="relative">
                        <div
                          ref={outLineWidthDropDownBtnRef}
                          onClick={() =>
                            setOutLineWidthDropdown(!outLineWidthDropdown)
                          }
                          className="relative cursor-pointer flex gap-2.5 p-[13px] lg:p-[11px] px-[14px] lg:px-[15px] justify-between items-center rounded-md bg-light_bg_v4 dark:bg-[#404040] mt-2.5"
                        >
                          <div className="flex justify-center items-center">
                            {darkMode ? <BrushDark /> : <Brush />}
                          </div>
                          <div className="w-full capitalize bg-transparent text-small2 lg:text-small1 dark:text-color_v2_dark">
                            {selectedOutlineWidth
                              ? selectedOutlineWidth
                              : " Width"}
                          </div>
                          <div className=" flex justify-center items-center">
                            {darkMode ? (
                              <DownArrowIconDark />
                            ) : (
                              <DownArrowIcon />
                            )}
                          </div>
                        </div>
                        {outLineWidthDropdown && (
                          <div
                            ref={outLineWidthDropDownRef}
                            className="absolute top-12 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5 dark:bg-[#404040] rounded-lg border flex flex-col max-h-20 overflow-y-auto"
                          >
                            {outLineWidth.map((item, i) => {
                              return (
                                <div
                                  key={i}
                                  onClick={() => {
                                    setSelectedOutlineWidth(item);
                                    setOutLineWidthDropdown(false);
                                  }}
                                  className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v2_dark cursor-pointer hover:bg-light_bg_v4 dark:hover:bg-dark-secondary rounded-md"
                                >
                                  {item}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>

                      <div className="relative flex items-center justify-start w-full mt-5">
                        <div
                          ref={outlineColrDropDownBtnRef}
                          onClick={() =>
                            setOpenAvatarColopicker(!openAvatarColopicker)
                          }
                          style={{
                            background: colorAvatar,
                          }}
                          className={`rounded-md me-[16px] border lg:me-[19px] cursor-pointer min-w-[48px] w-[48px] min-h-[48px] h-[48px] lg:min-w-[48px] lg:w-[48px] lg:min-h-[48px] lg:h-[48px] `}
                        ></div>

                        {openAvatarColopicker && (
                          <div
                            className="absolute top-0 lg:w-[80%] 2xl:w-[60%] w-full pb-5 "
                            style={{ zIndex: "999999999" }}
                          >
                            <div
                              ref={outlineColrDropDownRef}
                              className="border shadow-xl bg-white rounded-lg p-3"
                            >
                              <ColorPicker
                                color={color}
                                onChange={setColor}
                                hideInput={true}
                                height={150}
                              />
                              <div className="flex flex-wrap justify-center items-center -mt-[8px] gap-2 px-2">
                                <div className="flex justify-center items-center gap-1 w-full">
                                  <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                                    <p>HEX</p>
                                  </div>
                                  <p>:</p>
                                  <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                                    <p>{color.hex}</p>
                                  </div>
                                </div>
                                <div className="flex gap-1 justify-between w-full ">
                                  <div className="border rounded-md px-1 py-0.5 text-small1">
                                    {Math.round((color.rgb.a / 1) * 100)}%
                                  </div>
                                  <button
                                    className="rounded-full px-3 text-small2_b leading-none cursor-pointer bg-main_color text-white hover:opacity-70"
                                    onClick={() =>
                                      setOpenAvatarColopicker(false)
                                    }
                                  >
                                    DONE
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="w-full overflow-hidden">
                          <div className="text-small2 text-body_copy_medium_color dark:text-color_v1_dark">
                            {/* Color */}
                            {tComponent("header.color")}
                          </div>
                          <div className="text-small2_b text-heading_color ">
                            <input
                              value={colorAvatar}
                              type="text"
                              className="focus:outline-none -mt-[8px] dark:bg-dark-secondary dark:text-color_v1_dark"
                              onChange={(e) => {
                                setColor((color) => {
                                  return { ...color, hex: e.target.value };
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div className="flex mt-[26px] items-center justify-end">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(true)}
                  className="flex justify-center items-center"
                >
                  {darkMode ? <TrashIconDark /> : <TrashIcon />}
                  <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark">
                    {tComponent("header.delete_cap")}
                  </p>
                </button>

                <ExtraSmallFilledButton
                  name={`${tComponent("header.save_cap")}`}
                  buttonType={"submit"}
                  classes={"ms-3"}
                  isLoading={subLoader}
                />
              </div>
            </form>
          </div>
        </div>
      </I18nextProvider>
    </>
  );
};

export default EditAvatar;
